import { Injectable, signal } from '@angular/core';

@Injectable({
	providedIn: 'root'
})
export class SpinnerService {
	private static requestCounter = 0;

	_isLoading = signal<boolean>(false);
	_message = signal<string>('');

	get isLoading() {
		return this._isLoading;
	}

	get message() {
		return this._message;
	}

	show(message = ''): void {
		SpinnerService.requestCounter++;
		this._isLoading.set(true);
		this._message.set(message);
	}

	hide(): void {
		SpinnerService.requestCounter--;
		if (SpinnerService.requestCounter <= 0) {
			this._isLoading.set(false);
		}
	}
}
